import React from "react";
import "./Accomplishment.css";

const Accomplishment = ({ data }) => {
  return (
    <ul className="accomplishment">
      {data.map((bullet, index) => (
        <li key={index}>{bullet}</li>
      ))}
    </ul>
  );
}

export default Accomplishment;
